export { ActivityCorrectionPoints, type ActivityCorrectionPointsProps } from "./ActivityCorrectionPoints"
